import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';

export default function HelpDialog({ open, onClose }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>How to use 1-Minute-Minis</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    <strong>Add a mini to your library</strong><br />
                    Drag any image from a web page and drop it onto the Library panel on the left.
                    The image is saved locally in your browser — no account required.
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <strong>Add a mini to a sheet</strong><br />
                    Drag a creature from the Library onto the sheet canvas, or drop a web image
                    directly onto the canvas to add it to both the library and the sheet at once.
                    You can also drop a local image file from your computer.
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <strong>Resize &amp; configure</strong><br />
                    Click a creature in the library to edit its name, base size, and height ratio.
                    Adjust the count and size of each group directly on the sheet.
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <strong>Print</strong><br />
                    Click <strong>Print</strong> to generate a print-ready layout.
                    Use landscape orientation with zero margins for accurate scale.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    Source code &amp; issues:{' '}
                    <Link href="https://github.com/mijak99/paper-minis" target="_blank" rel="noreferrer">
                        github.com/mijak99/paper-minis
                    </Link>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
